"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.algorandBuildTransaction = void 0;
var errors_1 = require("@ledgerhq/errors");
var buildBigNumber_1 = require("../../libcore/buildBigNumber");
var tokens_1 = require("./tokens");
var setInfo = function (core, buildedTransaction, transaction, subAccount, account, isPartial) { return __awaiter(void 0, void 0, void 0, function () {
    var amount, recipient, assetId, mode, useAllAmount, targetAssetId, asaTransferInfo, paymentinfo;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                amount = transaction.amount, recipient = transaction.recipient, assetId = transaction.assetId, mode = transaction.mode, useAllAmount = transaction.useAllAmount;
                if (!(subAccount || (assetId && mode === "optIn"))) return [3 /*break*/, 3];
                targetAssetId = subAccount && subAccount.type === "TokenAccount"
                    ? (0, tokens_1.extractTokenId)(subAccount.token.id)
                    : assetId
                        ? (0, tokens_1.extractTokenId)(assetId)
                        : "";
                if (targetAssetId === "") {
                    throw new Error("Token Asset Id not found");
                }
                return [4 /*yield*/, core.AlgorandAssetTransferInfo.init(targetAssetId, useAllAmount && subAccount
                        ? subAccount.balance.toString()
                        : amount.toString(), recipient, null, null, null)];
            case 1:
                asaTransferInfo = _a.sent();
                return [4 /*yield*/, buildedTransaction.setAssetTransferInfo(asaTransferInfo)];
            case 2:
                _a.sent();
                return [3 /*break*/, 6];
            case 3: return [4 /*yield*/, core.AlgorandPaymentInfo.init(recipient, useAllAmount
                    ? isPartial
                        ? account.spendableBalance.toString()
                        : account.spendableBalance.minus(transaction.fees || 0).toString()
                    : amount.toString(), null, null)];
            case 4:
                paymentinfo = _a.sent();
                return [4 /*yield*/, buildedTransaction.setPaymentInfo(paymentinfo)];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}); };
function algorandBuildTransaction(_a) {
    var account = _a.account, core = _a.core, coreAccount = _a.coreAccount, transaction = _a.transaction, isCancelled = _a.isCancelled, isPartial = _a.isPartial;
    return __awaiter(this, void 0, void 0, function () {
        var fees, memo, subAccountId, subAccount, algorandAccount, buildedTransaction, feesToSet, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    fees = transaction.fees, memo = transaction.memo, subAccountId = transaction.subAccountId;
                    subAccount = subAccountId
                        ? account.subAccounts &&
                            account.subAccounts.find(function (t) { return t.id === subAccountId; })
                        : null;
                    if (isPartial === false && !fees) {
                        throw new errors_1.FeeNotLoaded();
                    }
                    return [4 /*yield*/, coreAccount.asAlgorandAccount()];
                case 1:
                    algorandAccount = _d.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, algorandAccount.createTransaction()];
                case 2:
                    buildedTransaction = _d.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    // set Payment or Asset if token
                    return [4 /*yield*/, setInfo(core, buildedTransaction, transaction, subAccount, account, isPartial)];
                case 3:
                    // set Payment or Asset if token
                    _d.sent();
                    if (!memo) return [3 /*break*/, 5];
                    return [4 /*yield*/, buildedTransaction.setNote(memo)];
                case 4:
                    _d.sent();
                    _d.label = 5;
                case 5:
                    if (!isPartial) return [3 /*break*/, 8];
                    _c = buildBigNumber_1.libcoreAmountToBigNumber;
                    return [4 /*yield*/, algorandAccount.getFeeEstimate(buildedTransaction)];
                case 6: return [4 /*yield*/, _c.apply(void 0, [_d.sent()])];
                case 7:
                    _b = _d.sent();
                    return [3 /*break*/, 9];
                case 8:
                    _b = fees;
                    _d.label = 9;
                case 9:
                    feesToSet = _b;
                    if (!feesToSet) return [3 /*break*/, 11];
                    return [4 /*yield*/, buildedTransaction.setFee(feesToSet.toString())];
                case 10:
                    _d.sent();
                    _d.label = 11;
                case 11: 
                // return transaction
                return [2 /*return*/, buildedTransaction];
            }
        });
    });
}
exports.algorandBuildTransaction = algorandBuildTransaction;
exports["default"] = algorandBuildTransaction;
//# sourceMappingURL=libcore-buildTransaction.js.map